// appTimezone — pin every DISPLAYED date/time to Ottawa (America/Toronto),
// whatever the viewer's machine timezone is. WolfDrivers is in-house software
// for an Ottawa cannabis-delivery operation, so a dispatcher in Pakistan and an
// admin in Ottawa must read the SAME wall clock on every card, report and chat
// (per the owner, 2026-08-18).
//
// Only the *formatting* methods are patched — the toLocaleString family, whose
// whole job is to render a human string. The raw getters (getHours/getDate/…)
// are deliberately left alone: they drive date-range math (start/end of day,
// "last 30 days" filters, chart buckets) that must stay anchored to real time,
// not shift with a display timezone.
//
// Callers keep the last word: any call passing its own `timeZone` still wins,
// because the Ottawa default is spread FIRST and the caller's options after it.

const DISPLAY_TZ = 'America/Toronto';

export function installOttawaTimezone(): void {
  const proto = Date.prototype as any;
  if (proto.__ottawaTZ) return; // idempotent — StrictMode double-mount / HMR
  proto.__ottawaTZ = true;

  for (const method of ['toLocaleString', 'toLocaleDateString', 'toLocaleTimeString'] as const) {
    const original = proto[method];
    proto[method] = function (this: Date, locales?: any, options?: any) {
      return original.call(this, locales, { timeZone: DISPLAY_TZ, ...(options || {}) });
    };
  }
}
